export enum Flags {
    showDefault = "showDefault",
    showPersonalInfo = "showPersonalInfo",
    showFamilyInfo = "showFamilyInfo",
    showResidenceInfo = "showResidenceInfo",
    showPermAddressInfo = "showPermAddressInfo",
    showEmploymentInfo = "showEmploymentInfo",
    showWorkInfo = "showWorkInfo",
    showFinanceBasicInfo = "showFinanceBasicInfo",
    showFinanceAssetsInfo = "showFinanceAssetsInfo",
    showDocumentsInfo = "showDocumentsInfo",
    showBankStatementInfo = "showBankStatementInfo",
    showFormComplete = "showFormComplete",
    showGetStarted = "showGetStarted",
    editForm = "editForm",
    nonServiceable = "nonServiceable",
    firstTime = "firstTime",
    showDeliveryAddress = "showDeliveryAddress",
    showLoanAmountTenure = "showLoanAmountTenure",
    showApply = "showApply",
    showReferences = "showReferences",
    showIncompleteInfo = "showIncompleteInfo",
    showIncompleteTrigger = "showIncompleteTrigger",
    showConsentLoanDetails =  "showConsentLoanDetail",
    showConsentDenied = "showConsentDenied",
    showDocConsent = "showDocConsent",
    showAppointment = "showAppointment",
    showEsign = "showEsign",
    showTimerDelay = "showTimerDelay",
    consentCompleted = "consentCompleted",
    showBankAccountInfo = "showBankAccountInfo",
    nachRedirection = "nachRedirection",
    oKycRedirection = "oKycRedirection",
    showPAForm = "showPAForm",
}
